/**
 * No-op logger — accepts any args but never outputs.
 */
const noop = (..._args: unknown[]) => {};

export const logger = {
  log: noop,
  error: noop,
  warn: noop,
  info: noop,
  debug: noop,
};

export default logger;
